import { State } from '../index';
import { EVENT_CATEGORY_KEY, EventCategoriesState } from '../reducers/eventCategoriesWithAssignments.reducer';
import { createSelector } from '@ngrx/store';

export const selectEventCategoriesState = (state: State) => state[EVENT_CATEGORY_KEY];

export const selectEventCategories = createSelector(
    selectEventCategoriesState,
    (state: EventCategoriesState) => state.categoriesWithAssignments
);

export const selectEventCategoriesFetched = createSelector(
    selectEventCategoriesState,
    (state: EventCategoriesState) => state.fetched
);
